<div class="container mt-6">
  <div class="text-center">
    <strong class="mainHeading">User Menu Configuration</strong>
  </div>
</div>

<div class="d-flex justify-content-start mb-3">
  <button
    *ngIf="userType == '6'"
    class="btn btn-primary"
    (click)="openAddMenuConfigModal(menuConfigModal)"
  >
    Add Menu Configuration
  </button>
</div>

<div class="card shadow">
  <div class="card-body">
    <h2 class="card-title text-start mb-1">Menu Mapping List :-</h2>

    <div class="table-responsive">
      <table class="table table-striped table-bordered text-center mb-0">
        <thead class="table-light">
          <tr>
            <!-- <th>Sl.No.</th> -->
            <th>User</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          @for (menu of menuMappingList; track menu.id) {
            <tr>
              <td>
                @switch (menu.userType.toString()) {
                  @case ('1') { Individual Requester }
                  @case ('2') { Corporate Requester }
                  @case ('3') { Dumpster }
                  @case ('4') { Dump Yard }
                  @case ('5') { Admin }
                  @case ('6') { SuperAdmin }
                  @case ('7') { SuperExecutive }
                  @case ('8') { SuperFinance }
                  @case ('9') { Executive }
                  @case ('10') { Finance }
                  @case ('11') { Baldia }
                  @default { Unknown }
                }
              </td>
              <td>
                <i
                  class="bi bi-pencil cursor-pointer"
                  (click)="openEditMenuConfigModal(menu, menuConfigModal)"
                ></i>
              </td>
            </tr>
          }
          @if (!menuMappingList || menuMappingList.length === 0) {
            <tr>
              <td colspan="11">No data to display!</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #menuConfigModal let-modal>
  <!-- Modal Header -->
  <div class="modal-header custom-modal-header">
    <h2 class="modal-title mt-3">
      {{ isEditMode ? "Edit Menu Configuration" : "Add Menu Configuration" }}
    </h2>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
    ></button>
  </div>

  <!-- Modal Body -->
  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center gap-2">
          <label for="userType">User Type :</label>
          <select
            class="form-select w-25"
            aria-label="Default select example"
            [disabled]="isEditMode"
            [(ngModel)]="selectedUserType"
          >
            <option selected disabled>Select User</option>
            <option
              *ngFor="let option of userTypeList"
              [value]="option?.userTypeID"
            >
              {{ option.userType }}
            </option>
          </select>
        </div>

        <div
          class="mt-2"
          ngbAccordion
          #accordion="ngbAccordion"
          [closeOthers]="false"
          [animation]="true"
        >
          <div
            [ngbAccordionItem]="mainMenuItem.menuName"
            *ngFor="let mainMenuItem of mainMenuList; let i = index"
            [collapsed]="false"
          >
            <h2 ngbAccordionHeader>
              <button ngbAccordionButton>
                <input
                  class="form-check-input me-2"
                  type="checkbox"
                  [id]="mainMenuItem.id"
                  [value]="mainMenuItem.id"
                  [(ngModel)]="mainMenuItem.isSelected"
                  (change)="onCheckboxChange(i, $event)"
                  (click)="$event.stopPropagation()"
                />
                {{ mainMenuItem.menuName }}
              </button>
            </h2>

            <div ngbAccordionCollapse>
              <div ngbAccordionBody>
                <ng-template>
                  <ng-container>
                    <div class="row">
                      <div
                        *ngFor="
                          let submenu of mainMenuItem.subMenus;
                          let j = index
                        "
                        class="col-md-4 mb-2"
                      >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            [id]="submenu.subMenuName"
                            [(ngModel)]="submenu.isSelected"
                            [value]="submenu.id"
                            (change)="onSubmenuCheckboxChange(i, $event, j)"
                          />
                          <label
                            class="form-check-label"
                            [for]="submenu.subMenuName"
                            >{{ submenu.subMenuName }}</label
                          >
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="mainMenuItem.subMenus.length == 0">
                    <p>No submenus available for this menu item.</p>
                  </ng-container>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Footer -->
  <div class="modal-footer">
    <button type="button" class="btn btn-danger" (click)="onSubmit()">
      <i class="bi bi-check-circle me-2"></i> Submit
    </button>

    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">
      <i class="bi bi-x-circle me-2"></i> Cancel
    </button>
  </div>
</ng-template>
